import client from '../client';

const BASE = '/api/administrator/faq';

export const readFaqList = ({ keyword, categoryMainId, categorySubId, isActive, status, page }) =>
    client.get(BASE, {
        params: {
            keyword: keyword || undefined,
            category_main_id: categoryMainId || undefined,
            category_sub_id: categorySubId || undefined,
            is_active: isActive === null || isActive === undefined ? undefined : isActive,
            status: status || undefined,
            page,
            pagesize: 15
        }
    });

export const readFaqDetail = ({ id }) =>
    client.get(`${BASE}/${id}`);

export const createFaq = ({ title, question, answer, categoryMainId, categorySubId, changeReason, isActive }) =>
    client.post(BASE, {
        title,
        question,
        answer,
        category_main_id: categoryMainId,
        category_sub_id: categorySubId,
        change_reason: changeReason || null,
        is_active: isActive
    });

export const updateFaq = ({ id, title, question, answer, categoryMainId, categorySubId, changeReason, isActive }) =>
    client.put(`${BASE}/${id}`, {
        title,
        question,
        answer,
        category_main_id: categoryMainId,
        category_sub_id: categorySubId,
        change_reason: changeReason || null,
        is_active: isActive
    });

export const deleteFaq = ({ id }) =>
    client.delete(`${BASE}/${id}`);

export const bulkUploadFaq = (formData) =>
    client.post(`${BASE}/bulk-upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [(data) => data]
    });
